import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc, propBool, propOneOf, } from '../../../../helpers/custom-prop-types';
import ExaminationAlertAndHeadCardFullModal from '../../../Ui/Modal/ExaminationAlertAndHeadCardFullModal';
import LoginRequiredHooksModal from '../../../Ui/Modal/LoginRequiredHooksModal';
import OtherProfessionalAlertModal from '../../../Ui/Modal/OtherProfessionalAlertModal';
const ProfessionalUnitAlertModal = (props) => {
    const { hideModal, isShow, userMode } = props;
    if (userMode === 'guest') {
        return _jsx(LoginRequiredHooksModal, { hideModal: hideModal, isShow: isShow });
    }
    if (userMode === 'pre') {
        return (_jsx(ExaminationAlertAndHeadCardFullModal, { isShow: isShow, onClickClose: hideModal }));
    }
    if (userMode === 'other') {
        return _jsx(OtherProfessionalAlertModal, { hideModal: hideModal, isShow: isShow });
    }
    return null;
};
ProfessionalUnitAlertModal.propTypes = {
    hideModal: propFunc().isRequired,
    isShow: propBool().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitAlertModal;
